import {getUrl, getUrlSync, getUrlCars, getUrlCarsSync, getBreadcrumbs, getMetadata} from './Engine/Engine';
import searchTextFromUrl from './Dissector/searchTextFromUrl';
import locationFromUrl from './Location/locationFromUrl';
import LocationData from './Location/LocationData';
import { withBaseFilters } from './Engine/BaseFilters';

export const constructUrl = (selectedFilters, selectedFiltersForApi, location) =>
  getUrl(withBaseFilters(selectedFilters), selectedFiltersForApi, location);

export const constructUrlSync = (selectedFilters, selectedFiltersForApi, location) =>
  getUrlSync(withBaseFilters(selectedFilters), selectedFiltersForApi, location);

export const constructBreadcrumbs = (selectedFilters, selectedFiltersForApi, allowCvnaid = true) =>
  getBreadcrumbs(withBaseFilters(selectedFilters), selectedFiltersForApi, allowCvnaid);

export const constructMetadata = (selectedFilters, location) =>
  getMetadata(withBaseFilters(selectedFilters), location);


// deconstructor
export const getSearchTextFromUrl = url =>
  searchTextFromUrl(url);

// deconstructor
export const getLocationFromUrl = (url, locationData = LocationData) =>
  locationFromUrl(url, locationData);

// perf testing
export const constructUrlPerfCars = (selectedFilters, selectedFiltersForApi, location) =>
  getUrlCars(withBaseFilters(selectedFilters), selectedFiltersForApi, location);

export const constructUrlPerfCarsSync = (selectedFilters, selectedFiltersForApi, location) =>
  getUrlCarsSync(withBaseFilters(selectedFilters), selectedFiltersForApi, location);
